module.exports = __webpack_public_path__ + "img/TEN.34ce077d.svg";